import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {SpinnerService} from './spinner.service';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../shared.module';
import { GrpcWebErrrHandlingImpl } from '../../services/grpc-client';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  imports: [SharedModule, NgxSpinnerModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers:[NgxSpinnerService]
})
export class SpinnerComponent implements OnInit {
  isLoading = false;
  constructor(private _loaderService: SpinnerService,
              private spinner: NgxSpinnerService,
              private grpcClient: GrpcWebErrrHandlingImpl) { }

  ngOnInit() {
    this._loaderService.isLoading.asObservable().subscribe(v => {
      if (v) {
        this.spinner.show().then();
      } else {
        this.spinner.hide().then();
      }
    });
    this.grpcClient.loading$.subscribe(
      (loading) => {
        if(loading) {
          this.spinner.show().then();
        } else {
          this.spinner.hide().then();
        }
      }
    );
  }

}
